// extracted by mini-css-extract-plugin
export default {"modalContent":"modal_modalContent__Ib9Aq","antdModal":"modal_antdModal__hHd++"};